import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Cotizacion4 from "./Cotizacion4ConfirmacionRenovacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { consultarPlacaFetch, obtenerDatosClienteFetch, listarECivilesFetch, listarGenerosFetch, listarProvinciasFetch, listarCiudadesFetch, obtenerDatosFetch, guardarDatosAsegurado, obtenerDatosClienteFetchRenovacion } from "../../../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import { ambienteAplicacion } from "../../../../constants/urls";
import { urlListarRenovaciones } from "../../api/urls";
import { httpClient } from "../../../../api/httpClient";
//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";

class ContainerCotizacion4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      productoExterno: false,
      renovacion: null
    }
    this.onChangeProvincia = this.onChangeProvincia.bind(this);
  }

  async componentDidMount() {

    const idCliente = this.props.datosCarrito.productosCarrito.cliCodigoCoreContratante

    let renovacion = await this.obtenerRenovacion()
    if (renovacion.transaccion && renovacion.arrayrenovaciones && renovacion.arrayrenovaciones.length > 0) {
      let renovacionVer = renovacion.arrayrenovaciones[0]

      let esProductoExterno = renovacionVer.productoExterno

      this.setState({
        productoExterno: esProductoExterno,
        renovacion: renovacionVer
      })



    }


    if (this.props.datosCarrito.productosCarrito.carProductos && this.props.datosCarrito.productosCarrito.carProductos[0] && this.props.datosCarrito.productosCarrito.carProductos[0].datosAsegurado) {
      this.props.setDatosPersonaAsegurado(this.props.datosCarrito.productosCarrito.carProductos[0].datosAsegurado);
    }



    await this.props.getDatosCliente(idCliente);
    await this.props.listarEstadosCiviles();
    await this.props.listarGeneros();
    //await this.props.listarCiudades();
    await this.props.listarProvincias();
    this.setState({
      cargando: false
    })


  }

  async obtenerRenovacion() {


    //return {transaccion: true}
    try {


      const url = `${urlListarRenovaciones}${this.props.datosUsuarios.brokerCodigo}&cliCodigoCore=${this.props.datosUsuarios.cliCodigoCore}&ambiente=${ambienteAplicacion}&ramo=VEH%C3%8DCULOS`;
      const json = await httpClient.post(url, {
        "rangoFecha": null,
        "filtrosAtributos": {
          "reIdCarrito": this.props.datosCarrito.productosCarrito.idCarrito,
        }
      });

      return json;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }

  async onChangeProvincia(param) {
    //console.log("Provincia seleccionada ",param)
    await this.props.listarCiudades(param);

  }
  textosCargando() {
    if (this.state.cargando)
      return "Cargando información para el pago..."
    if (this.props.catalogos.listarCiudadesIsLoading)
      return "Cargando catálogo de ciudades..."
    if (this.props.datosCotizacion.obtenerDatosClienteIsLoading)
      return "Cargando datos del cliente..."
    if (this.props.datosPago.guardarDtosIsLoading)
      return "Guardando información. Por favor espere..."

  }

  consultaCargarDatos = (params) => {

    const { cedula, tipo, personeria } = params;
    this.props.consultarDatos(cedula, tipo, personeria);
  }


  render() {
    const { cargando } = this.state;
    const { catalogos, datosCotizacion } = this.props;
    return (
      <LoadingScreen
        loading={cargando || catalogos.listarCiudadesIsLoading || datosCotizacion.obtenerDatosClienteIsLoading || this.props.datosPago.guardarDtosIsLoading || this.props.datosListaNegra.listaNegraLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        <main className="cr-app bg-light">
          <div className="cr-content container-fluid">
            <div className="container-body-spaces">
              {this.state.renovacion &&
                <Cotizacion4 datosCarrito={this.props.datosCarrito} renovacion={this.state.renovacion} onChangeProvincia={this.onChangeProvincia} consultaCargarDatos={this.consultaCargarDatos} productoExterno={this.state.productoExterno} />
              }

            </div>
          </div>
        </main>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({

  datosCotizacion: state.datosCotizacion,
  datosCarrito: state.dataProductoCarrito,
  catalogos: state.catalogosCotizacion,
  datosPago: state.datosPago,
  datosListaNegra: state.datosListaNegra,
  datosUsuarios: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = dispatch => {
  return {
    consultarPlaca: placa => dispatch(consultarPlacaFetch(placa)),
    getDatosCliente: idCliente => dispatch(obtenerDatosClienteFetchRenovacion(idCliente)),
    listarEstadosCiviles: () => dispatch(listarECivilesFetch()),
    listarGeneros: () => dispatch(listarGenerosFetch()),
    listarProvincias: () => dispatch(listarProvinciasFetch()),
    listarCiudades: (provincia) => dispatch(listarCiudadesFetch(provincia)),
    consultarDatos: (cedula, tipo, personeria) => dispatch(obtenerDatosFetch(cedula, tipo, personeria)),
    setDatosPersonaAsegurado: (datos) => dispatch(guardarDatosAsegurado(datos))

  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacion4)
);
